import { render } from "./FixedCard.vue?vue&type=template&id=6167fb76"
const script = {}
script.render = render

export default script